/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getOrder} from '../api'

 export const useQueryGetOrder = createReactQueryHook('getOrder', getOrder)
